export const merchNames = [
  'Aprons N/A',
  'Aprons XS',
  'Aprons S',
  'Aprons M',
  'Aprons L',
  'Aprons XL',
  'Aprons XXL',
  'Aprons XXXL',
  'Aprons XXXXL',

  'Backpacks N/A',
  'Backpacks XS',
  'Backpacks S',
  'Backpacks M',
  'Backpacks L',
  'Backpacks XL',
  'Backpacks XXL',
  'Backpacks XXXL',
  'Backpacks XXXXL',

  'Badge N/A',
  'Badge XS',
  'Badge S',
  'Badge M',
  'Badge L',
  'Badge XL',
  'Badge XXL',
  'Badge XXXL',
  'Badge XXXXL',

  'Beanie N/A',
  'Beanie XS',
  'Beanie S',
  'Beanie M',
  'Beanie L',
  'Beanie XL',
  'Beanie XXL',
  'Beanie XXXL',
  'Beanie XXXXL',

  'Gloves N/A',
  'Gloves XS',
  'Gloves S',
  'Gloves M',
  'Gloves L',
  'Gloves XL',
  'Gloves XXL',
  'Gloves XXXL',
  'Gloves XXXXL',

  'Hat N/A',
  'Hat XS',
  'Hat S',
  'Hat M',
  'Hat L',
  'Hat XL',
  'Hat XXL',
  'Hat XXXL',
  'Hat XXXXL',

  'Jumpers N/A',
  'Jumpers XS',
  'Jumpers S',
  'Jumpers M',
  'Jumpers L',
  'Jumpers XL',
  'Jumpers XXL',
  'Jumpers XXXL',
  'Jumpers XXXXL',

  'Polos N/A',
  'Polos XS',
  'Polos S',
  'Polos M',
  'Polos L',
  'Polos XL',
  'Polos XXL',
  'Polos XXXL',
  'Polos XXXXL',

  'Rainjackets N/A',
  'Rainjackets XS',
  'Rainjackets S',
  'Rainjackets M',
  'Rainjackets L',
  'Rainjackets XL',
  'Rainjackets XXL',
  'Rainjackets XXXL',
  'Rainjackets XXXXL',

  'Shorts N/A',
  'Shorts XS',
  'Shorts S',
  'Shorts M',
  'Shorts L',
  'Shorts XL',
  'Shorts XXL',
  'Shorts XXXL',
  'Shorts XXXXL',

  'T-shirt N/A',
  'T-shirt XS',
  'T-shirt S',
  'T-shirt M',
  'T-shirt L',
  'T-shirt XL',
  'T-shirt XXL',
  'T-shirt XXXL',
  'T-shirt XXXXL',

  'Totes Bag N/A',
  'Totes Bag XS',
  'Totes Bag S',
  'Totes Bag M',
  'Totes Bag L',
  'Totes Bag XL',
  'Totes Bag XXL',
  'Totes Bag XXXL',
  'Totes Bag XXXXL',

  'Trolleys N/A',
  'Trolleys XS',
  'Trolleys S',
  'Trolleys M',
  'Trolleys L',
  'Trolleys XL',
  'Trolleys XXL',
  'Trolleys XXXL',
  'Trolleys XXXXL',

  'FLAGS N/A',
  'FLAGS XS',
  'FLAGS S',
  'FLAGS M',
  'FLAGS L',
  'FLAGS XL',
  'FLAGS XXL',
  'FLAGS XXXL',
  'FLAGS XXXXL',

  'CAPS N/A',
  'CAPS XS',
  'CAPS S',
  'CAPS M',
  'CAPS L',
  'CAPS XL',
  'CAPS XXL',
  'CAPS XXXL',
  'CAPS XXXXL',
]

// numbers match date-fns, getDay(date)

export const days = [
  {
    number: 1,
    name: 'Monday',
  },
  {
    number: 2,
    name: 'Tuesday',
  },
  {
    number: 3,
    name: 'Wednesday',
  },
  {
    number: 4,
    name: 'Thursday',
  },
  {
    number: 5,
    name: 'Friday',
  },
  {
    number: 6,
    name: 'Saturday',
  },
  {
    number: 0,
    name: 'Sunday',
  },
]

export const weeks = ['Current Week', 'Next Week']

export const Presets = {
  0: 'ALL',
  1: "TODAY'S PICKUPS",
  2: "TOMORROW'S PICKUPS",
}
